// @flow
import type { AllowedFilters } from '../types/List'

export type AllowedParam =
  | AllowedFilters
  | 'parent_id'
  | 'doc_id'
  | 'id'
  | 'offer'
  | 'page'
  | 'planned'
  | 'redirect_to'
  | 'token'

export default function getParamFromUrl (
  param: AllowedParam,
  url: string = global.location.href
): string {
  return new global.URL(url).searchParams.get(param) || ''
}
